import script from "./MtcConnectionView.vue?vue&type=script&setup=true&lang=js"
export * from "./MtcConnectionView.vue?vue&type=script&setup=true&lang=js"

import "./MtcConnectionView.vue?vue&type=style&index=0&id=f63eb3e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f63eb3e8"]])

export default __exports__